import AmioHttpService from './amio-http.service'

// PRO-671: the bot-level AI agent settings. Keyed by botId — the API decides whether the values are stored on
// the multi-bot group or the standalone bot, so this layer never deals with that distinction.
class AgentSettingsService extends AmioHttpService {
  async get(botId) {
    const { data } = await this.requestGet(`/bots/${botId}/agent-settings`)
    return this._adaptData(data)
  }

  async update(botId, settings) {
    const { data } = await this.requestPut(`/bots/${botId}/agent-settings`, settings)
    return this._adaptData(data)
  }

  _adaptData(data) {
    return {
      botId: data.bot_id,
      multiBotId: data.multi_bot_id,
      language: data.language,
      settings: data.settings || {},
      // The org name, offered as the Company placeholder — a suggestion, never written for the customer.
      companySuggestion: data.company_suggestion || '',
      // The assembled system message, rendered server-side by the same builder the bot runs on.
      preview: data.preview || ''
    }
  }
}

export default new AgentSettingsService()
